import React from "react";

import { formatElapsed } from "../util/liveMatchUtil";

// A plain red pulse is deliberate: gold is reserved for rank/achievement
// accents, the win/draw/loss tokens are reserved for form pips, and
// zone-releg is a standings-stripe token — none of those fit "this match
// is happening right now" semantically. Red is the near-universal,
// unambiguous "live" convention in sports UIs and doesn't collide with any
// reserved token.
export const PulseDot = () => (
  <span className="relative flex h-2 w-2">
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
    <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500" />
  </span>
);

// `compact`: the dense inline badge used in MatchList's MatchRow, matching
// its finished-score badge's sizing (text-[17px]/font-display) but with a
// red tint instead of neutral gray, so a live row reads as distinct from
// both a finished score and a kickoff-time badge.
// Full (default): the larger badge used in MatchHero's center slot on the
// match page, matching FinishedMatchStatistics' own score-block sizing.
const LiveScoreBadge = ({ homeScore, awayScore, elapsed, compact = false }) => {
  if (compact) {
    return (
      <span className="flex items-center gap-1.5 rounded bg-red-50 px-2.5 py-0.5 font-display text-[17px] font-semibold text-red-700 dark:bg-red-900/40 dark:text-red-300">
        <PulseDot />
        <span>{homeScore}</span>
        <span className="opacity-40">–</span>
        <span>{awayScore}</span>
        {elapsed && <span className="text-[10px] font-medium opacity-70">{formatElapsed(elapsed)}</span>}
      </span>
    );
  }

  return (
    <div className="flex items-center gap-2.5 rounded bg-white/10 px-4 py-2">
      <PulseDot />
      <span className="font-display text-3xl font-bold tabular-nums text-white sm:text-4xl">{homeScore}</span>
      <span className="text-white/30">–</span>
      <span className="font-display text-3xl font-bold tabular-nums text-white sm:text-4xl">{awayScore}</span>
      {elapsed && <span className="ml-1 text-[11px] font-medium text-red-300">{formatElapsed(elapsed)}</span>}
    </div>
  );
};

export default LiveScoreBadge;
